var raFormLayoutLanguageEnglish = {
    'ra-form-layout': {
        action: {
            next: 'Next',
            previous: 'Previous',
        },
    },
};
export default raFormLayoutLanguageEnglish;
